<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/6chap1#chap1">Images</a></p>
<p class="toc1"><a href="#/7chap2#chap2">Macedon</a></p>
<p class="toc1"><a href="#/8chap3#chap3">Troy</a></p>
<p class="toc1"><a href="#/9chap4#chap4">Persia</a></p>
<p class="toc1"><a href="#/10chap5#chap5">India</a></p>
<p class="toc1"><a href="#/11chap6#chap6">The March to Babylon</a></p>
<p class="toc1"><a href="#/12chap7#chap7">Postscript</a></p>
<p class="toc1"><a href="#/13chap8#chap8">Ancient Sources</a></p>
<p class="toc1"><a href="#/23index#index">Index</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/14biography#biography">A Biography of Mary Renault</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?6573eef8